import "@stripe/stripe-js";
import ReactDOM from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import { TwitchRelinkPrompt } from "./components/twitch/TwitchRelinkPrompt";
import { UpdatePrompt } from "./components/version";
import "./index.css";
import ApolloProvider from "./providers/ApolloProvider";
import { AuthProvider } from "./providers/AuthProvider";
import ThemeProvider from "./providers/ThemeProvider";
import { router } from "./router/browserRouter";

ReactDOM.createRoot(document.getElementById("root")!).render(
    <ThemeProvider>
        <ApolloProvider>
            <AuthProvider>
                <RouterProvider router={router} />
                <UpdatePrompt />
                <TwitchRelinkPrompt />
            </AuthProvider>
        </ApolloProvider>
    </ThemeProvider>,
);
